import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import { useAuthStore } from '../stores/auth'
import { useTenantGuardStore } from '../stores/tenant-guard'

const routes: Array<RouteRecordRaw> = [
  // ... rest of routes (omitted for brevity in replace tool but I must provide full context)
  {
    path: '/',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      { path: 'dashboard', name: 'dashboard', component: () => import('../pages/admin/dashboard/Dashboard.vue') },
      {
        path: 'tenants',
        name: 'tenants',
        component: () => import('../pages/tenants/TenantsList.vue'),
        meta: { title: 'Üye İş Yerleri' },
      },
      {
        path: 'tenants/new',
        name: 'newTenant',
        component: () => import('../pages/tenants/NewTenant.vue'),
        meta: { title: 'Yeni İş Yeri' },
      },
      {
        path: 'tenants/:id',
        name: 'tenantDetail',
        component: () => import('../pages/tenants/TenantDetail.vue'),
        props: true,
      },
      {
        path: 'packages',
        name: 'packages',
        component: () => import('../pages/packages/PackagesList.vue'),
        meta: { title: 'Paketler' },
      },
      {
        path: 'packages/:id',
        name: 'packageDetail',
        component: () => import('../pages/packages/PackageDetail.vue'),
        props: true,
      },
      {
        path: 'api-permissions',
        name: 'apiPermissions',
        component: () => import('../pages/packages/PermissionsList.vue'),
        meta: { title: 'Yetki Yönetimi' },
      },
      {
        path: 'tenantReviews',
        name: 'tenantReviews',
        component: () => import('../pages/tenantReviews/TenantReviews.vue'),
      },
      {
        path: 'subscription-requests',
        name: 'subscriptionRequests',
        component: () => import('../pages/subscriptions/SubscriptionRequests.vue'),
        meta: { title: 'Abonelik Talepleri' },
      },
      {
        path: 'system-settings',
        name: 'systemSettings',
        component: () => import('../pages/system-settings/SystemSettings.vue'),
        meta: { title: 'Sistem Ayarları' },
      },
    ],
  },
  {
    path: '/auth/',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach((to, _from, next) => {
  const auth = useAuthStore()
  const guard = useTenantGuardStore()
  auth.loadFromSession()

  if (to.matched.some((r) => r.meta?.requiresAuth)) {
    if (!auth.isAuthenticated) return next({ name: 'login' })
  }

  if (to.name === 'newTenant' && !guard.isVerified) {
    guard.openModal('newTenant')
    if (_from.name && _from.name !== 'newTenant') {
      return next(false)
    }
  }

  next()
})

export default router
